<script>
'use strict';

const StoryCard = require('./StoryCard.vue');

module.exports = {
  name: 'StoryList',
  components: {
    StoryCard,
  },
  props: {
    stories: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 0,
    },
    context: {
      type: String,
      default: 'stories-tab',
      validator: (val) =>
        ['stories-tab', 'top-results', 'products-sidebar'].includes(val),
    },
  },
  computed: {
    storeLimit() {
      return this.$store.state.storiesLimit;
    },
    effectiveLimit() {
      // props limit (for top-results) takes priority, otherwise use store limit
      return this.limit > 0 ? this.limit : this.storeLimit;
    },
    visibleStories() {
      return this.stories.slice(0, this.effectiveLimit);
    },
    hasMore() {
      return this.stories.length > this.visibleStories.length;
    },
    showSeeAll() {
      const context = ['top-results', 'products-sidebar'].includes(
        this.context
      );

      return context && this.stories.length > 0;
    },
    variation() {
      return this.context === 'top-results' ? 'recirc' : 'normal';
    },
    showNoResults() {
      return this.$store.getters.storyResults.length === 0;
    },
  },
  methods: {
    loadMore() {
      this.$store.commit('showAllStories');
    },
    setActiveTab(tab) {
      this.$store.commit('setActiveTab', tab);
    },
  },
};
</script>

<template>
  <div class="story-list">
    <StoryCard
      v-for="(article, index) in visibleStories"
      :key="article.articleId"
      :article="article"
      :variation="variation"
      :position="index + 1"
    />
    <div
      v-if="context === 'stories-tab' && hasMore"
      @click="loadMore"
      class="story-list-action"
    >
      <div class="icon"></div>
      <span class="link">See more articles</span>
    </div>
    <div
      v-if="showSeeAll"
      @click="setActiveTab('stories')"
      class="story-list-action"
    >
      <div class="icon"></div>
      <span class="link">See all story results</span>
    </div>
    <div v-show="showNoResults" class="no-results-container">
      <div class="no-results-text">
        <div>Sorry, there are no matching results for this search</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss"></style>
